module.exports = __webpack_public_path__ + "img/grey1.4a2fe891.jpg";